// src/components/AdminDashboard.js
import React, { useContext } from 'react';
import { Routes, Route, NavLink, Navigate, Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { auth } from '../firebase';
import { toast } from 'react-toastify';
import AdminHome from './AdminHome';
import AdminUserList from './AdminUserList';
import AdminVideoList from './AdminVideoList';
import BetaUserManager from './admin/BetaUserManager';

function AdminDashboard() {
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/');
      toast.success('Successfully logged out');
    } catch (error) {
      toast.error('Failed to log out');
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
        <div className="flex space-x-4 items-center">
          <Link to="/" className="text-gray-600 hover:text-gray-900 transition font-medium">
            Home
          </Link>
          <Link to="/profile" className="text-gray-600 hover:text-gray-900 transition font-medium">
            Profile
          </Link>
          <button
            onClick={handleLogout}
            className="text-gray-600 hover:text-gray-900 transition font-medium"
          >
            Logout
          </button>
        </div>
      </div>

      <nav className="mb-6 bg-white p-4 rounded shadow">
        <ul className="flex space-x-6">
          <li>
            <NavLink to="home" className={({ isActive }) => (isActive ? 'text-blue-500 font-semibold' : 'hover:text-blue-500 font-medium')}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="users" className={({ isActive }) => (isActive ? 'text-blue-500 font-semibold' : 'hover:text-blue-500 font-medium')}>
              Users
            </NavLink>
          </li>
          <li>
            <NavLink to="videos" className={({ isActive }) => (isActive ? 'text-blue-500 font-semibold' : 'hover:text-blue-500 font-medium')}>
              Videos
            </NavLink>
          </li>
          <li>
            <NavLink to="beta" className={({ isActive }) => (isActive ? 'text-blue-500 font-semibold' : 'hover:text-blue-500 font-medium')}>
              Beta Program
            </NavLink>
          </li>
          <li>
            <Link to="/blog/admin" className="text-gray-600 hover:text-blue-500 font-medium">
              Blog Manager
            </Link>
          </li>
        </ul>
      </nav>

      <Routes>
        <Route path="home" element={<AdminHome />} />
        <Route path="users" element={<AdminUserList />} />
        <Route path="videos" element={<AdminVideoList />} />
        <Route path="beta" element={<BetaUserManager />} />
        <Route path="" element={<Navigate to="home" replace />} />
        <Route path="*" element={<Navigate to="home" replace />} />
      </Routes>
    </div>
  );
}

export default AdminDashboard;
